
import { mapGetters } from 'vuex'
import { openWxFollow } from '@/settings'
// import VueQr from "vue-qr";
export default {
    components: {
        // VueQr,
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            qrUrl: 'user/qrUrl'
        }),
        openWxFollowBox() {
            return openWxFollow
        },
        isOfficialAccount() {
            return this.userinfo && this.userinfo.isOfficialAccount
        },
        isLogin() {
            return this.userinfo && this.userinfo.id
        }
    },
    props: {
        pageName: {
            type: String,
            required: true
        },
        descText: {
            type: String,
            default: '关注后才能进行商品发布'
        }
    },
    data() {
        return {
            logoSrc: 'https://oss.pzds.com/imgv2/20211223100751.png',
            timer: null,
            setTimeOutTimer: null,
            margin: 10,
            dialogForWxFollow: false, //公众号弹窗
            qr: 'https://oss.pzds.com/imgv2/20211223104117.png'
        }
    },
    watch: {
        dialogForWxFollow: function (v) {
            if (this.pageName === 'release-dialog') {
                if (v) {
                    this.$store.dispatch('user/UserGetWxFollow')
                    this.timer = setInterval(() => {
                        this.$store.dispatch('user/UserGetInfo').then((res) => {
                            if (res.data.isOfficialAccount) {
                                this.$message.success('感谢您对盼之的支持！')
                                this.dialogForWxFollow = false
                                clearInterval(this.timer)
                                clearInterval(this.setTimeOutTimer)
                            }
                        })
                    }, 1000)
                    // 1分钟没动就不调用接口
                    this.setTimeOutTimer = setTimeout(() => {
                        clearInterval(this.timer)
                    }, 60000)
                } else {
                    clearInterval(this.timer)
                }
            }
        }
    }
}
